import { IApplicationState } from "../store/IApplicationState";
import { AppUtils } from "../utils/app-utils";
import { DealerSearchFilters } from "./models/dealers/dealer-search-filters";
import { UserSearchFilters } from "./models/users/user-search-filters";

/**
 * Get the cached params or return a new instance
 * @param state The redux state
 */
export const getUserSearchFilters = (state : IApplicationState) : UserSearchFilters => {
    const cached = state.support.userSearchFilters;
    return AppUtils.IsEmpty(cached)
                ? new UserSearchFilters()
                : cached!;
};

/**
 * Get the cached dealer filter or return a new instance
 * @param state The redux state
 */
export const getDealerSearchFilters = (state : IApplicationState) : DealerSearchFilters => {
    const cached = state.support.dealerSearchFilters;
    return AppUtils.IsEmpty(cached)
                ? new DealerSearchFilters()
                : cached!;
};
